import { Component, ChangeDetectorRef, ElementRef, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { ETLReportingSetReturnTypes, ETLReportingSetSimpleFieldReturnOptions, OperationSymbols, SingleFieldTypes } from '../../cxone-etl-reporting-set.model';
import { DatePipe, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'cv-tree-builder',
    templateUrl: './tree-builder.component.html',
    styleUrls: ['./tree-builder.component.scss'],
    providers: [TitleCasePipe]
})
export class TreeBuilderComponent implements OnInit {
    @ViewChildren('drawLinesRef') drawLinesRefElements!: ElementRef;
    @Output() treeInputClick = new EventEmitter<void>();
    @Input() dataFieldRef = null;
    lines = [];
    content = 'short';
    selectedElement: any;
    selectedElementIndex = 0;
    outputForm = {};
    treeScale = 1;
    validateAllFormsAreValid: boolean;
    constructor(private cdRef: ChangeDetectorRef, private datePipe: DatePipe) { }

    ngOnInit() {
        this.drawBasic();
        this.cdRef.detectChanges();
    }

    drawBasic() {
        this.addSample(null, null, null, null, true);
    }

    addSample(item, prevNodeObj, selectedElemet, parentItem, isItfromMainChild = false) {
        if (this.lines.length === 0) {
            this.lines = [...[], ...[{
                from: '0',
                to: '1',
                elementPosition: {
                    x: 0,
                    y: 0
                },
                position: {
                    from: ['bottom', 'bottom'],
                    to: ['top', 'top'],
                },
                type: 'simple',
                id: '0',
                form: { name: 'undefined', isValid: false }
            },
            {
                elementPosition: {
                    x: 0,
                    y: 60
                },
                position: {
                    from: ['bottom', 'bottom'],
                    to: ['top', 'top'],
                },
                type: 'simple',
                id: '1',
                form: { name: '', isValid: false }
            }]];
        } else {
            const renderedElement = selectedElemet.getBoundingClientRect();
            const obj = [{
                from: String(prevNodeObj?.uniqueId),
                to: String(item.uniqueId),
                elementPosition: {
                    x: selectedElemet?.offsetLeft,
                    y: renderedElement.bottom - 90
                },
                position: {
                    from: ['bottom', 'bottom'],
                    to: ['top', 'top'],
                },
                type: 'simple',
                id: String(item.uniqueId),
                form: item
            }
            ];
            this.lines = [...this.lines, ...obj];
            this.validateByType(this.lines[this.lines.length - 1], item);
            if (item.childs.length === 0 && !isItfromMainChild) {
                this.buildObjectForTree(item);
                this.addChildDataDynamically(parentItem);
            }
        }
    }

    setSelectedElement(ind, item) {
        this.selectedElementIndex = ind;
        this.treeInputClick.emit(item);
    }

    buildTreeStructure(treeData) {
        if (!treeData) {
            this.outputForm = null;
            this.lines = [];
        } else if (treeData) {
            const data = JSON.parse(JSON.stringify(treeData));
            this.outputForm = data;
            this.lines = [];
            this.treeScale = 1;
            let top = document.getElementsByClassName('right-section-with-config-pane');
            if (top !== null) {
                top[0].scrollIntoView();
                top = null;
            }
            this.buildObjectForTree(data.child);
            this.addSample(null, null, null, null, true);
            if (data && data.hasOwnProperty('child')) {
                this.lines[0].form = data;
                this.validateByType(this.lines[0], data);
                this.lines[1].form = data.child;
                this.validateByType(this.lines[1], data.child);
                this.lines = [...this.lines];
                setTimeout(() => {
                    if (data.child.childs.length > 0) {
                        if (data.child.childs.length === 1) {
                            const prevNodeObj = data.child;
                            this.buildObjectForTree(data.child.childs[0]);
                            this.addLinesData(data.child.childs[0], prevNodeObj, '1', null, true);
                        } else if (data.child.childs.length > 1) {
                            this.addChildDataDynamically(data.child);
                        }
                    }
                }, 0);
            }
        }
    }

    async addChildDataDynamically(parentItem: any) {
        setTimeout(async () => {
            if (parentItem.currentIndex === undefined && parentItem.childs.length > 0) {
                parentItem.currentIndex = 0;
                this.buildTree(parentItem, parentItem.childs[parentItem.currentIndex]);
            } else if (parentItem.currentIndex > -1 && (parentItem.currentIndex + 1) < parentItem.childs.length) {
                parentItem.currentIndex += 1;
                this.buildTree(parentItem, parentItem.childs[parentItem.currentIndex]);
            } else if ((parentItem.currentIndex + 1) >= parentItem.childs.length) {
                delete parentItem.currentIndex;
                const currentItem = this.getCurrentIndexItem(parentItem.parentId);
                if (currentItem.child != undefined && currentItem.child.currentIndex != undefined && currentItem.child.currentIndex != -1) {
                    this.addChildDataDynamically(currentItem.child);
                } else if (currentItem.type === "Conditional" && currentItem.childs.length === 3 && currentItem.currentIndex === 2) {
                    if (currentItem.childs[2].currentIndex + 1 >= currentItem.childs[2].childs.length) {
                        delete currentItem.currentIndex;
                    }
                    if (currentItem.childs[2].hasOwnProperty('currentIndex')) {
                        this.addChildDataDynamically(currentItem.childs[2]);
                    } else {
                        const nextNode = this.getCurrentIndexItem(currentItem.parentId);
                        if (nextNode?.currentIndex != undefined && nextNode.currentIndex != -1) {
                            this.addChildDataDynamically(nextNode);
                        }
                    }
                }
                else if (currentItem?.currentIndex != undefined && currentItem.currentIndex != -1) {
                    this.addChildDataDynamically(currentItem);
                }
            }
        }, 0);
    }

    getCurrentIndexItem(parentId) {
        const node = this.dataFieldRef.findNodeById(this.outputForm, parentId);
        if (node.child && node.currentIndex != -1) {
            return node.child;
        }
        else if (node.hasOwnProperty('parentId') && !node.hasOwnProperty('currentIndex')) {
            return this.getCurrentIndexItem(node.parentId);
        } else if (!node.hasOwnProperty('parentId') && !node.hasOwnProperty('currentIndex')) {
            return null;
        }
        return node;
    }

    async buildTree(parentItem, item) {
        if (item) {
            this.buildObjectForTree(item);
            const parentElement = document.getElementById('tree-' + parentItem.uniqueId);
            this.selectedElement = parentElement;
            this.addChildLines(parentItem, item);
            if (item.childs.length === 1) {
                if (item.childs[0].type === "Conditional" || item.type === "Conditional" || item.childs[0].type === "ComplexDate" || item.type === "ComplexDate") {
                    this.addChildDataDynamically(item);
                } else {
                    const prevNodeObj = item;
                    this.addLinesData(item.childs[0], prevNodeObj, item.uniqueId, parentItem);
                }
            } else if (item.childs.length > 1) {
                this.addChildDataDynamically(item);
            }
        }
    }

    buildObjectForTree(item) {
        if (item && item.hasOwnProperty('type')) {
            if (item.type === "Conditional") {
                this.conditionsObjectForTree(item);
            } else if (item.type === "ComplexNumeric") {
                this.complexNumericObjectForTree(item);
            } else if (item.type === "ComplexDate") {
                this.complexDateObjectForTree(item);
            } else if (item.type === "Substring") {
                if (item.childs.length > 0) {
                    item.nodeLabel = 'Input';
                    item.nodeLabelType = "compare";
                }
            } else if (item.type === "Coalesce") {
                if (item.childs.length > 0) {
                    item.nodeLabel = 'Fields';
                    item.nodeLabelType = "compare";
                }
            }
        }
    }

    complexDateObjectForTree(item) {
        if (item.hasOwnProperty('leftOperand')) {
            item.childs.push(item.leftOperand[0]);
        }
        if (item.hasOwnProperty('rightOperand')) {
            item.childs.push(item.rightOperand[0]);
        }
        if (item.hasOwnProperty('seconds')) {
            item.childs.push(item.seconds[0]);
        }
        if (item.hasOwnProperty('minutes')) {
            item.childs.push(item.minutes[0]);
        }
        if (item.hasOwnProperty('hours')) {
            item.childs.push(item.hours[0]);
        }
        if (item.hasOwnProperty('days')) {
            item.childs.push(item.days[0]);
        }
        if (item.hasOwnProperty('months')) {
            item.childs.push(item.months[0]);
        }
    }

    complexNumericObjectForTree(item) {
        if (item.hasOwnProperty('formulas')) {
            let uniqueId = Number(item.uniqueId + '1000');
            item.formulas.forEach(formula => {
                uniqueId += 1;
                if (formula.numericType === "expression") {
                    formula.name = 'Field Expression';
                    formula.uniqueId = uniqueId;
                    formula.parentId = item.uniqueId;
                } else {
                    const operationName = formula?.operations?.label.replace(' ', '');
                    formula.name = OperationSymbols[operationName] ? `${OperationSymbols[operationName]} ${formula?.operations?.label}` : formula?.operations?.label;
                    formula.uniqueId = uniqueId;
                    formula.parentId = item.uniqueId;
                }
                item.childs.push(formula);
            });
        }
    }

    conditionsObjectForTree(item) {
        let uniqueId = Number(item.uniqueId + '0000');
        item.childs = [];
        if (item.hasOwnProperty('positive') && item.positive.length > 0) {
            item.positive[0].nodeLabel = "True";
            item.positive[0].nodeLabelType = "";
            item.childs.push(item.positive[0]);
        } else {
            item.childs.push({
                nodeLabel: 'True',
                "isValid": false,
                uniqueId: uniqueId,
                childs: [],
                name: '',
                parentId: item.uniqueId,
                nodeLabelType: ""
            });
            uniqueId += 1;
        }
        if (item.hasOwnProperty('negative') && item.negative.length > 0) {
            item.negative[0].nodeLabel = "False";
            item.negative[0].nodeLabelType = "";
            item.childs.push(item.negative[0]);
        } else {
            item.childs.push({
                nodeLabel: 'False',
                "isValid": false,
                uniqueId: uniqueId,
                childs: [],
                name: '',
                parentId: item.uniqueId,
                nodeLabelType: ""
            });
            uniqueId += 1;
        }
        item.childs.push({
            nodeLabel: '',
            "isValid": false,
            childs: [],
            uniqueId: uniqueId,
            name: item?.operatorDropdown?.label,
            parentId: item.uniqueId,
            nodeLabelType: ""
        });
        if (item.hasOwnProperty('comparisons')) {
            for (let a = 0; a < item.comparisons.length; a++) {
                const comp = item?.comparisons[a];
                const singleFieldTypes = SingleFieldTypes;
                if (comp.hasOwnProperty('field1') && comp.field1.length > 0) {
                    if (comp.field1[0].childs.length === 0) {
                        if (comp.hasOwnProperty('field2') && comp.field2.length == 0 && item?.comparisons.length == 1) {
                            item.childs[2].nodeLabel = comp.comparisonType?.value;
                            item.childs[2].nodeLabelType = 'compare';
                        } else {
                            comp.field1[0].nodeLabel = comp.comparisonType?.value;
                            comp.field1[0].nodeLabelType = (singleFieldTypes.includes(comp.field1[0].nodeLabel) || (comp.hasOwnProperty('field2') && comp.field2.length == 0)) ? '' : 'compare';
                        }
                    }
                    item.childs[item.childs.length - 1].childs.push(comp.field1[0]);
                } else {
                    uniqueId += 1;
                    item.childs[item.childs.length - 1].childs.push({
                        nodeLabel: '',
                        "isValid": false,
                        childs: [],
                        uniqueId: uniqueId,
                        name: '',
                        parentId: item.uniqueId
                    });
                }
                if (comp.hasOwnProperty('field2') && comp.field2.length > 0) {
                    comp.field2[0].nodeLabel = "";
                    if (comp.field1[0].childs.length > 0) {
                        comp.field2[0].nodeLabel = comp.comparisonType?.value;
                        comp.field2[0].nodeLabelType = '';
                        item.childs[item.childs.length - 1].childs[a].childs.unshift(comp.field2[0]);
                    } else {
                        item.childs[item.childs.length - 1].childs[a].childs.push(comp.field2[0]);
                    }
                }
            }
            item.childs[2].isValid = (item.hasOwnProperty('operatorDropdown') && Object.keys(item.operatorDropdown).length > 0 && item.comparisons.length > 0);

        }
    }

    addLinesData(item, prevNodeObj, uniqueId, parentItem, isItfromMainChild = false) {
        setTimeout(() => {
            const selectedElemet = document.getElementById('tree-' + uniqueId);
            this.addSample(item, prevNodeObj, selectedElemet, parentItem, isItfromMainChild);
            if (item.childs.length === 1) {
                this.buildObjectForTree(item.childs[0]);
                this.addLinesData(item.childs[0], item, item.uniqueId, parentItem, isItfromMainChild);
            } else if (item.childs.length > 1) {
                this.addChildDataDynamically(item);
            }
        }, 0);
    }

    addChildLines(parentItem, currentItem) {
        setTimeout(() => {
            const element = document.getElementById('tree-' + this.lines[this.lines.length - 1]?.id);
            if (element) {
                const renderedElement = element.getBoundingClientRect();
                const bottomPosition = (renderedElement.bottom - 90);
                const obj = [{
                    from: String(parentItem?.uniqueId),
                    to: currentItem.uniqueId + 'span',
                    elementPosition: {
                        x: this.selectedElement.offsetLeft + 49,
                        y: bottomPosition + 10
                    },
                    position: {
                        from: ['bottom', 'bottom'],
                        to: ['top', 'center'],
                    },
                    type: 'span',
                    form: currentItem,
                    id: currentItem.uniqueId + 'span',
                },
                {
                    from: currentItem.uniqueId + 'span',
                    to: String(currentItem.uniqueId),
                    elementPosition: {
                        x: this.selectedElement.offsetLeft + 120,
                        y: bottomPosition - 7
                    },
                    position: {
                        from: ['center', 'right'],
                        to: ['center', 'left'],
                    },
                    type: 'simple',
                    id: String(currentItem.uniqueId),
                    form: currentItem,

                }];
                this.lines = [...this.lines, ...obj];
                this.validateByType(this.lines[this.lines.length - 1], currentItem);
                if (currentItem.childs.length === 0) {
                    this.addChildDataDynamically(parentItem);
                }
            }
        }, 0);
    }

    zoomOut() {
        if (Number(this.treeScale.toFixed(1)) > 0.7) {
            this.treeScale -= 0.1;
        }
    }

    zoomIn() {
        if (Number(this.treeScale.toFixed(1)) <= 1) {
            this.treeScale += 0.1;
        }
    }

    validateAllTreeForms(): boolean {
        let treeData = this.lines;
        treeData.forEach(treeNode => {
            let form = this.dataFieldRef.findNodeById(this.dataFieldRef.outputForm, treeNode.form.uniqueId);
            if (form) {
                treeNode.form = { ...treeNode.form, ...form };
                this.validateByType(treeNode, form);
            }
        });
        return this.validateAllFormsAreValid;
    }

    validateByType(treeNode, form) {
        if (form.uniqueId === 0) {
            treeNode.form.isValid = !(form.name === "undefined" || form.name === "");
            this.validateAllFormsAreValid = treeNode.form.isValid;
        }
        if (form.hasOwnProperty('name') && (form.name?.toUpperCase() === "OR" || form.name?.toUpperCase() === "AND")) {
            let parentForm = this.dataFieldRef.findNodeById(this.dataFieldRef.outputForm, treeNode.form.parentId);
            if (parentForm.type === "Conditional") {
                this.validateAllFormsAreValid = this.validateConditional(treeNode, parentForm, true);
            }
        }
        switch (form.type) {
            case "Simple":
                this.validateAllFormsAreValid = this.validateSimple(treeNode, form);
                break;
            case "Coalesce":
                this.validateCoalesce(treeNode, form);
                break;
            case "Substring":
                this.validateSubstring(treeNode, form);
                break;
            case "ComplexString":
                this.validateComplexString(treeNode, form);
                break;
            case "Conditional":
                this.validateAllFormsAreValid = this.validateConditional(treeNode, form);
                break;
            case "ComplexNumeric":
                this.validateComplexNumeric(treeNode, form);
                break;
            case "ComplexDate":
                this.validateComplexDate(treeNode, form);
                break;
            case "Regex":
                this.validateRegex(treeNode, form);
                break;
        }
    }

    validateSimple(treeNode, form) {
        let isValid = false;
        if (form.hasOwnProperty('simpleFieldType')) {
            if (form.simpleFieldType.IsNull === true) {
                treeNode.form.name = 'NULL';
            } else if (form.simpleFieldType?.return?.id === 1) {
                const simpleName = form.simpleFieldType?.Field?.Name || "Simple";
                treeNode.form.name = simpleName;
            } else {
                let simpleName = (form.simpleFieldType.DefaultValue !== 'null' || !form.simpleFieldType.DefaultValue) ? '"' + form.simpleFieldType?.DefaultValue + '"' : 'Simple';
                simpleName = form.simpleFieldType.expectedReturnType?.id === ETLReportingSetReturnTypes.DATE ? this.datePipe.transform(simpleName, 'mediumDate') : (simpleName).toUpperCase();
                if (form.simpleFieldType?.Field?.Name && form.simpleFieldType?.return?.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE) {
                    treeNode.form.name = form.simpleFieldType?.Field?.Name;
                } else {
                    treeNode.form.name = simpleName;
                }
            }
            if (form.simpleFieldType.isValid) {
                isValid = true;
            } else {
                isValid = false;
            }
        }
        return isValid;
    }

    validateCoalesce(treeNode, form) {
        treeNode.form.isValid = form.childs.length > 0;
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }

    validateSubstring(treeNode, form) {
        treeNode.form.isValid = form.childs.length > 0 && form.hasOwnProperty('pattern') && form.pattern !== "";
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }

    validateComplexString(treeNode, form) {
        treeNode.form.isValid = form.childs.length > 0;
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }

    validateConditional(treeNode, form, isCompare = false): boolean {
        let isValid = true;
        if (!form.hasOwnProperty('comparisons')) {
            isValid = false;
        }
        for (let a = 0; a < form?.comparisons?.length; a++) {
            const compareItem = form?.comparisons[a];
            if (compareItem.comparisonType === "") {
                isValid = false;
                break;
            }
            const singleFieldValues = SingleFieldTypes;
            if (singleFieldValues.includes(compareItem.comparisonType.value)) {
                if (compareItem.field1.length == 0) {
                    isValid = false;
                    break;
                }
            } else {
                if (compareItem.field1.length === 0 || compareItem.field2.length === 0) {
                    isValid = false;
                    break;
                }
            }
        }
        treeNode.form.isValid = false;
        if (isCompare === false) {
            if (isValid &&
                (form?.negative?.length > 0) &&
                (form?.positive?.length > 0) && form.hasOwnProperty('operatorDropdown') && Object.keys(form.operatorDropdown).length > 0 && form.operatorDropdown.label != "-") {
                treeNode.form.isValid = true;
            }
        } else {
            treeNode.form.isValid = isValid;
        }
        return treeNode.form.isValid;
    }

    validateComplexNumeric(treeNode, form) {
        treeNode.form.isValid = form?.formulas?.length > 0;
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }

    validateComplexDate(treeNode, form) {
        treeNode.form.isValid = false;
        if (treeNode.form.operation && treeNode.form.operation.hasOwnProperty('id')) {
            if (treeNode.form.operation.id === 1) {
                treeNode.form.isValid =
                    (treeNode.form.hasOwnProperty('leftOperand') && treeNode.form.leftOperand.length > 0) &&
                    (treeNode.form.hasOwnProperty('rightOperand') && treeNode.form.rightOperand.length > 0) &&
                    (this.dataFieldRef.outputForm.returnType && this.dataFieldRef.outputForm.returnType.id == ETLReportingSetReturnTypes.DECIMAL_NUMBER);
            } else {
                treeNode.form.isValid =
                    (treeNode.form.hasOwnProperty('leftOperand') && treeNode.form.leftOperand.length > 0) &&
                    (treeNode.form.hasOwnProperty('days') && treeNode.form.days.length > 0) &&
                    (treeNode.form.hasOwnProperty('hours') && treeNode.form.hours.length > 0) &&
                    (treeNode.form.hasOwnProperty('minutes') && treeNode.form.minutes.length > 0) &&
                    (treeNode.form.hasOwnProperty('months') && treeNode.form.months.length > 0) &&
                    (treeNode.form.hasOwnProperty('seconds') && treeNode.form.seconds.length > 0) &&
                    (this.dataFieldRef.outputForm && this.dataFieldRef.outputForm.returnType.id == ETLReportingSetReturnTypes.DATE);
            }
        }
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }

    validateRegex(treeNode, form) {
        treeNode.form = { ...form };
        treeNode.form.isValid = false;
        if (form.childs.length > 0 && form.hasOwnProperty('expression') && form.expression !== '') {
            treeNode.form.isValid = true;
        }
        this.validateAllFormsAreValid = treeNode.form.isValid;
    }
}
